import {AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';
import type * as React from 'react';
import CapacityNavBar from '@/components/Capacity/CapacityNavBar';
import MyCapacityDashboardWrapper from '@/components/Capacity/MyCapacityDashboardWrapper';
import LoginDisplay from '@/components/LoginDisplay';
import {EmployeeProvider} from '@/context/AllEmployeesProvider';
import PreferencesProvider from '@/context/PreferencesProvider';

const MyCapacity = () : React.ReactElement => {
    return (
        <>
            <AuthenticatedTemplate>
                <PreferencesProvider categories={['dashboard', 'scheduler', 'capacity']}>
                    <CapacityNavBar/>
                    <EmployeeProvider>
                        <MyCapacityDashboardWrapper/>
                    </EmployeeProvider>
                </PreferencesProvider>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <LoginDisplay/>
            </UnauthenticatedTemplate>
        </>
    );
};

export default MyCapacity;
